export const createApiBody = (serviceName, resourceName, actionName, data) => {
	return {
		service: {
			name: serviceName,
			version: 'v1',
		},
		resource: {
			name: resourceName,
			version: 'v1',
		},
		action: {
			name: actionName,
			version: 'v1',
		},
		data: data,
	};
};
